module.exports = __webpack_public_path__ + "media/packs/images/flags/CO-6777c851014c856dfde90272c84e050e.png";